export const BROCHURES = {
  employer: {
    name: 'Employer financial wellbeing brochure',
    path: '/2026_GenMoney_Employees_Financial_Wellbeing_Brochure.pdf',
  },
  university: {
    name: 'University financial wellbeing brochure',
    path: '/2026_GenMoney_Student_Financial_Wellbeing_Brochure.pdf',
  },
};